import { atomWithStorage } from '@capsicum/common';

export const FTOHowToDrawerAtom = atomWithStorage<Array<string>>('fanTokenOfferingHowToDrawerSeenFor', []);
